export function mapObject(obj) {
    if (!obj) return {};

    return {
        ...obj,
        store: obj.store._id,
        brand: obj.brand._id,
        vmodel: obj.vmodel._id,
    };
}